// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-card{color:#2e3451;text-align:center;font-size:24px;margin:24px 0;font-weight:500}
`, "",{"version":3,"sources":["webpack://./src/app/components/TitleCard/styles.scss"],"names":[],"mappings":"AAAA,YACE,aAAc,CACd,iBAAkB,CAClB,cAAe,CACf,aAAc,CACd,eAAgB","sourcesContent":[".title-card {\n  color: #2e3451;\n  text-align: center;\n  font-size: 24px;\n  margin: 24px 0;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
